module.exports = __webpack_public_path__ + "media/images/billing-icon-15502a042e182083165e83287d3cfd92.png";